'use client';

import { useEffect } from 'react';

import { useRouter } from 'next/navigation';

import { LocaleType } from '@/i18n';
import { checkSlugValidity } from '@/utils/redirectOnSlugDifference';

interface RedirectOnSlugDifferenceProps {
  slugFromParams: string;
  slugFromData: string;
  page: {
    locale: LocaleType;
    pathname: string;
  };
}

export default function RedirectOnSlugDifference({
  slugFromParams,
  slugFromData,
  page,
}: RedirectOnSlugDifferenceProps) {
  const router = useRouter();

  const hash = typeof window !== 'undefined' ? window.location.hash : '';

  useEffect(() => {
    if (slugFromParams !== slugFromData) {
      if (
        !checkSlugValidity([slugFromParams, slugFromData], {
          slugFromData,
          slugFromParams,
          page,
        })
      ) {
        return;
      }

      const redirectPath = `/${page.locale}/${page.pathname}/${slugFromData}${hash}`;
      router.replace(redirectPath);
    }
  }, [slugFromParams, slugFromData, page, router, hash]);

  return null;
}
